import {
  React,
  useState,
  useEffect,
  useTranslation,
  useLocation,
  useDispatch,
  useSelector,
  PageLoader,
  useNavigate,
} from "../../Components/Imports/import";
import DefaultLayout from "../../Layouts/DefaultLayout/DefaultLayout";
import Nav from "react-bootstrap/Nav";
import "./VendorProfile.css";
import editLogo from "../../Assets/Images/editLogo.png";
import General from "../../Components/VendorProfile/VpGeneral";
import Financial from "../../Components/VendorProfile/VpFinancial";
import Commercial from "../../Components/VendorProfile/VpCommercial";
import Supplier from "../../Components/VendorProfile/VpSupplier";
import Hse from "../../Components/VendorProfile/VpHse";
import Categories from "../../Components/VendorProfile/VpCategories";
import VpDocuments from "../../Components/VendorProfile/VpDocuments";
import VpSummary from "../../Components/VendorProfile/VpSummary";
import ExportIcon from "../../Assets/Svg/export.svg";
import {
  clearSingleVendorData,
  getSingleVendorDetails,
} from "../../Store/Reducer/singleVendorDetails";
import useTypeQueryParam from "../../CustomHooks/useTypeQueryParam";
import { getAllLoginDetails } from "../../Store/Reducer/loginDetails";
import store from "../../Store/store";
import {
  clearStoreInfo,
  clearLatestVendorInfo,
} from "../../Store/actions/updateVendorAction";
import { clearVendorTableList } from "../../Store/Reducer/vendorTable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const VendorProfile = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [type, setType] = useState(queryParams.get("type") || "General");
  const [docEdit, setDocEdit] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [commercialRegType, getCommercialRegType] = useState("");
  const [paymentMethod, getPaymentMethod] = useState("");
  const { singleVendorDetails, loading } = useSelector(
    (state) => state.singleVendor
  );

  const [generalInfoData, getGeneralInfoData] = useState({});

  useTypeQueryParam(type, queryParams);
  const { LoginDetails, loading: userLoginLoading } = useSelector(
    (state) => state.loginDetails
  );
  const [hasAccess, setHasAccess] = useState(false);
  const assignerType = [
    "ACT Division Group",
    "ACT Verify Group",
    "ACT Sap Group",
    "ACT Department Group",
  ];
  useEffect(() => {
    dispatch(getAllLoginDetails());
  }, []);
  useEffect(() => {
    const getAssignerType = LoginDetails?.assigner_type
      ? LoginDetails?.assigner_type.split(",")
      : [];
    const checkAccess = getAssignerType?.some(
      (type) => !assignerType.includes(type)
    );
    setHasAccess(checkAccess);
  }, [LoginDetails]);
  const handleTypeSelect = (selectedKey) => {
    if (!editMode) {
      setType(selectedKey);
    }
  };
  const handleLogout = () => {
    const language = localStorage.getItem("i18nextLng");
    localStorage.clear();
    if (language) {
      localStorage.setItem("i18nextLng", language);
    }
    store.dispatch(clearStoreInfo());
    store.dispatch(clearSingleVendorData());
    store.dispatch(clearVendorTableList());
    navigate("/");
  };

  const handleChangeEdit = () => {
    if (!hasAccess) {
      handleLogout();
    } else {
      setEditMode(true);
    }
  };

  useEffect(() => {
    dispatch(getSingleVendorDetails());
    
    return () => {
      dispatch(clearLatestVendorInfo());
    };
  }, []);

  const BASIC_FIELDS = [
    "vendor_code",
    "commercial_reg_type",
    "name_1",
    "name_2",
    "name_3",
    "name_4",
    "company_name_eng",
    "street_house_no",
    "district",
    "city",
    "postal_code",
    "language",
    "register_country",
    "contact_phone",
    "contact_email",
    "contact_email2",
    "bank_country_short",
    "bank_key",
    "registration_no",
    "type_of_business",
    "industry",
    "account_number",
    "bank_account_holder",
    "currency",
    "term_of_payment",
    "terms_details",
    "recon_account",
    "currency",
    "term_of_payment",
    "terms_details",
    "payment_method",
  ];

  const FIELD_LABELS = {
    vendor_code: "Vendor Code",
    commercial_reg_type: "Commerical Register Type",
    name_1: "Name 1",
    name_2: "Name 2",
    name_3: "Name 3",
    name_4: "Name 4",
    company_name_eng: "Search Name",
    street_house_no: "Street / House Number",
    district: "Province/States/City",
    city: "District",
    postal_code: "Postal Code",
    register_country: "Country",
    language: "Language",
    contact_phone: "Mobile Phone",
    contact_email: "E-mail address 1",
    contact_email2: "E-mail address 2",
    bank_country_short: "Bank Country",
    bank_key: "Bank Key",
    registration_no: "Vat Reg. NO",
    type_of_business: "Type of Business",
    industry: "Type of Industry",
    account_number: "Bank Account",
    bank_account_holder: "Account Name",
    currency: "Order Currency",
    term_of_payment: "Term of Payment",
    terms_details: "Term of Payment - Detail",
    recon_account: "Recon.Account",
    payment_method: "Payment Method",
  };

  const countryMapping = {
    Thailand: "TH",
    "United Kingdom": "UK",
    "United States of America": "USA",
    Japan: "JP",
    Taiwan: "TW",
    Germany: "DE",
    "Hong Kong and Shanghai": "HK/SH",
    France: "FR",
    China: "CN",
    "Australia and New Zealand": "AU/NZ",
    OTH: "OTH",
  };

  const exportToExcel = (singleVendorDetails) => {


    const data = BASIC_FIELDS?.map((key) => {
      let value = singleVendorDetails?.[key] ?? "";

      if (key === "language") {
        value =
          singleVendorDetails?.register_country === "Thailand" ? "TH" : "EN";
      }

      if (key.startsWith("name_")) {
        const companyName = singleVendorDetails?.company_name_eng ?? "";
        value = companyName?.slice(
          (parseInt(key?.split("_")[1]) - 1) * 25,
          parseInt(key?.split("_")[1]) * 25
        );
      }

      if (key === "term_of_payment") {
        const creditTerm = singleVendorDetails?.credit_term ?? "";
        value =
          creditTerm === "30Days"
            ? "PX30"
            : creditTerm === "Other"
            ? "OTH"
            : "NOT AVAILABLE";
      }

      if (key === "recon_account") {
        const typeOfBusiness = singleVendorDetails?.type_of_business ?? "";
        value =
          typeOfBusiness === "Rawmaterial"
            ? "2122000000"
            : typeOfBusiness?.length > 0 && typeOfBusiness !== "Rawmaterial"
            ? "2151900000"
            : "NOT AVAILABLE";
      }

      if (key === "bank_country_short") {
        const bankCountry = singleVendorDetails?.bank_name
          ?.match(/\(([^)]+)\)/)?.[1]
          ?.trim();
        value = countryMapping[bankCountry] || "N/A";
      }

      if (key === "bank_key") {
        value = singleVendorDetails?.bank_name?.match(/-(\d{7})$/)?.[1] || "N/A";
      }

      if (key === "terms_details") {
        const creditTerm = singleVendorDetails?.credit_term ?? "";
        value =
          creditTerm === "30Days"
            ? "(โอนเงิน30วันนับจากวันที่ในอินวอยซ์(ค่าธรรมเนียมหักsupplier))"
            : creditTerm === "Other"
            ? ""
            : "NOT AVAILABLE";
      }

      return {
        "FIELD NAME": FIELD_LABELS[key] || key,
        DATA: value?.toString()?.toUpperCase(),
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(data, {
      header: ["FIELD NAME", "DATA"],
    });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "VendorDetails");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "VendorDetails.xlsx");
  };

  return (
    <DefaultLayout>
      {(loading || pageLoading) && <PageLoader />}

      <section className="um-main">
        <div className="d-flex align-items justify-content-between">
          <div className="um-title-btn vp-title-btn">
            <h2 className="um-title">{t("Vendor Profile")}</h2>
            {type !== "Summary" && (
              <button
                onClick={handleChangeEdit}
                className="vendor-profile-edit"
                disabled={editMode}
              >
                <img src={editLogo} alt="" />
                {t("Edit")}
              </button>
            )}
          </div>
          {type === "Summary" && (
            <div className="um-title-btn">
              <button
                className="d-flex align-center export-btn"
                onClick={() => exportToExcel(singleVendorDetails)}
              >
                <img src={ExportIcon} alt="export_icon" />
                <p>Export CSV</p>
              </button>
            </div>
          )}
        </div>

        <Nav activeKey="" onSelect={handleTypeSelect} className="cv-navbar">
          <Nav.Item>
            <Nav.Link
              className={
                type === "General"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey={"General"}
            >
              <p
                className={
                  type === "General"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {" "}
                {t("General Info")}
              </p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={
                type === "categories"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey={"categories"}
            >
              <p
                className={
                  type === "categories"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {" "}
                {t("Bidding Categories")}
              </p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={
                type === "Financial"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey="Financial"
            >
              <p
                className={
                  type === "Financial"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {t("FinancialData/Health")}
              </p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={
                type === "Commercial"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey="Commercial"
            >
              <p
                className={
                  type === "Commercial"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {" "}
                {t("Commercial evaluation")}
              </p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={
                type === "Supplier"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey="Supplier"
            >
              <p
                className={
                  type === "Supplier"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {" "}
                {t("Supplier’s Quality")}
              </p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={
                type === "HSE"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey="HSE"
            >
              <p
                className={
                  type === "HSE"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {" "}
                {t("Suppliers’s HSE Management")}
              </p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={
                type === "Documents"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey="Documents"
            >
              <p
                className={
                  type === "Documents"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {" "}
                {t("Documents")}
              </p>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              className={
                type === "Summary"
                  ? "create-vendor-nav-active"
                  : "create-vendor-nav"
              }
              eventKey="Summary"
            >
              <p
                className={
                  type === "Summary"
                    ? "create-vendor-text-active"
                    : "create-vendor-text"
                }
              >
                {" "}
                {t("Summary")}
              </p>
            </Nav.Link>
          </Nav.Item>
        </Nav>
        {type === "General" && (
          <General
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode}
            oldData={singleVendorDetails}
            setDocEdit={setDocEdit}
            getCommercialRegType={getCommercialRegType}
            loading={setPageLoading}
            getGeneralInfoData={getGeneralInfoData}
          />
        )}
        {type === "categories" && (
          <Categories
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode}
            data={singleVendorDetails}
            loading={setPageLoading}
          />
        )}
        {type === "Financial" && (
          <Financial
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode}
            oldData={singleVendorDetails}
            getPaymentMethod={getPaymentMethod}
            setDocEdit={setDocEdit}
            loading={setPageLoading}
          />
        )}
        {type === "Commercial" && (
          <Commercial
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode}
            data={singleVendorDetails}
            loading={setPageLoading}
          />
        )}
        {type === "Supplier" && (
          <Supplier
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode}
            data={singleVendorDetails}
            loading={setPageLoading}
          />
        )}
        {type === "HSE" && (
          <Hse
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode}
            data={singleVendorDetails}
            setPageLoading={setPageLoading}
          />
        )}
        {type === "Documents" && (
          <VpDocuments
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode || docEdit}
            oldData={singleVendorDetails}
            setPageLoading={setPageLoading}
            setDocEdit={setDocEdit}
            docEdit={docEdit}
            commercialRegistrationType={commercialRegType}
            paymentMethod={paymentMethod}
            generalInfoData={generalInfoData}
          />
        )}
        {type === "Summary" && (
          <VpSummary
            setType={setType}
            setEditMode={setEditMode}
            editMode={editMode}
            data={singleVendorDetails}
          />
        )}
      </section>
    </DefaultLayout>
  );
};

export default VendorProfile;
